import { useEffect } from 'react';

import { ANALYTICS_OPERATIONAL_SUBJECT } from '../../constants/snippetAnalytics.ts';
import { setOnCreateError, type CreateErrorInfo } from '../../store/actions/createActions.ts';

import { useSnippetAnalytics } from './useSnippetAnalytics.ts';

/**
 * Fires `snippetApiCreate failed` (with `reason` + optional `statusCode`) on
 * create failures. Mount before any create can run (e.g. SnippetsProvider).
 */
export const useSnippetsCreateAnalytics = (): void => {
	const { fireFailedAnalytic } = useSnippetAnalytics();

	useEffect(() => {
		setOnCreateError((info: CreateErrorInfo) => {
			fireFailedAnalytic(ANALYTICS_OPERATIONAL_SUBJECT.SNIPPET_API_CREATE, {
				reason: info.reason,
				...(info.statusCode !== undefined && { statusCode: info.statusCode }),
			});
		});

		return () => {
			setOnCreateError(null);
		};
		// fireFailedAnalytic is memoised, so it's a stable dep.
	}, [fireFailedAnalytic]);
};
